import { PhonemeItem, segmentPhonemes } from "../phonemes/segmentPhonemes";

/** how to break words up into segments (groups of phonemes) */
export enum SegmentStrategy {
  /** break up everything into single characters, accepting any input */
  Single = 'raw',
  /** segment into IPA phonemes with diacrities, must be valid IPA */
  Ipa = 'ipa',
  /** IPA + modifier symbols such as ʷ */
  IpaModifier = 'ipaModifier',
  /** IPA + some non-standard symbols (numbers for phoneme length, in separate segment) */
  IpaPlus = 'ipaPlus',
  /** try segmenting as IpaPlus, non-IPA uses Single */
  PreferIpaPlus = 'preferIpaPlus',
  /** symbols used by the speech synthesizer */
  SynthSymbols = 'synthSymbols',
}

/**
 * break up a sentence into phoneme segments based on given strategy
 * returns [hasUnknowns, phonemes]
 */
export function intoSegments(sentence: string, strategy: SegmentStrategy, affricates?: 'all-aff' | 'en-aff'): [boolean, PhonemeItem[]] {
  if (strategy === SegmentStrategy.PreferIpaPlus) {
    const segmented = segmentPhonemes(sentence.trim(), 'ipaPlus', affricates);
    // remove all mentions of 'unknown'
    const withoutUnknown = segmented.phonemes.map(p => p.meta === 'unknown' ? { phoneme: p.phoneme } : p);
    return [false, withoutUnknown];
  }

  if (strategy === SegmentStrategy.Single) {
    const items = intoSingle(sentence);
    return [false, items];
  }

  const type = strategy === SegmentStrategy.SynthSymbols ? 'synth' : strategy;
  const segmented = segmentPhonemes(sentence.trim(), type, affricates);
  return [segmented.hasUnknown, segmented.phonemes];
}

function intoSingle(sentence: string): PhonemeItem[] {
  const items: PhonemeItem[] = [];
  for (const c of sentence) {
    if (c === ' ' || c === '\t') {
      items.push({ phoneme: ' ', meta: 'space' });
    } else if (c === '\n') {
      items.push({ phoneme: c, meta: 'newline' });
    } else if (c === ',' || c === '.') {
      items.push({ phoneme: c, meta: 'space' });
    } else {
      items.push({ phoneme: c });
    }
  }
  return items;
}
